import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { VideoCoursesActionType, VideoCoursesStore } from './VideoCoursesReducer.types';

// @ts-ignore
const initialState: VideoCoursesStore = Immutable.fromJS({
  isFetching: false,
  videoCourses: null,
  videoCourseItem: null,
  isFetchingCourse: false,
});

const VideoCoursesReducer = handleActions<any>(
  {
    REQUEST_VIDEO_COURSES: (state: VideoCoursesStore) => state.set('isFetching', true),

    RESPONSE_VIDEO_COURSES_FAILURE: (state: VideoCoursesStore) => state.set('isFetching', false),

    RESPONSE_VIDEO_COURSES_SUCCESS: (state: VideoCoursesStore, action: VideoCoursesActionType) => {
      const readings = Immutable.fromJS(action.payload);

      return state.set('isFetching', false).set('videoCourses', readings);
    },
    REQUEST_COURSE: (state: VideoCoursesStore) => state.set('isFetchingCourse', true),
    RESPONSE_COURSE_FAILURE: (state: VideoCoursesStore) => state.set('isFetchingCourse', false),
    RESPONSE_COURSE_SUCCESS: (state: VideoCoursesStore, action: VideoCoursesActionType) =>
      state.set('isFetchingCourse', false).set('videoCourseItem', Immutable.fromJS(action.payload)),
  },
  initialState
);

export default VideoCoursesReducer;
